import styles from "./job-opening-header.module.less";
import { useTranslation } from "react-i18next";

export type TJobOpeningHeaderProps = {
  heading: string;
};

export const JobOpeningHeader = ({ heading }: TJobOpeningHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className={[styles.wrapper, "max-width padded-sides"].join(" ")}>
      <div className={"text-max-width"}>
        <p className={"eyebrow"}>{t("JOB_AVAILABLE_POSITION")}</p>
        <h1 className={"h3"}>{heading}</h1>
      </div>
    </div>
  );
};

export default JobOpeningHeader;
